import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, shareReplay, take, tap, filter } from 'rxjs/operators';

import { sortByProperty } from '@mt-ng2/common-functions';

import { IState } from '@model/interfaces/state';
import { ICountry } from '@model/interfaces/country';
import { IMetaItem } from '@mt-ng2/base-service';
import { IUnitsOfMeasurement } from '@model/interfaces/units-of-measurement';
import { IAddressType } from '@model/interfaces/address-type';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    private _states: IState[];
    private _countries: ICountry[];
    private _psychologicalScreeningStatuses$ = this.http.get<IMetaItem[]>(`/options/psychologicalScreeningStatuses`).pipe(shareReplay(1), take(1));

    constructor(private http: HttpClient) { }

    getStates(): Observable<IState[]> {
        if (!this._states) {
            return this.http.get<IState[]>('/options/states').pipe(
                tap((answer) => {
                    sortByProperty(answer, 'Name');
                    this._states = answer;
                }),
            );
        } else {
            return of(this._states);
        }
    }

    getCountries(): Observable<ICountry[]> {
        if (!this._countries) {
            return this.http.get<ICountry[]>('/options/countries').pipe(
                tap((answer) => {
                    sortByProperty(answer, 'Name');
                    let indexOfUS = answer.findIndex((country) => country.CountryCode === 'US');
                    answer.splice(0, 0, answer.splice(indexOfUS, 1)[0]);
                    this._countries = answer;
                }),
            );
        } else {
            return of(this._countries);
        }
    }

    getPsychologicalScreeningStatuses(): Observable<IMetaItem[]> {
        return this._psychologicalScreeningStatuses$;
    }

    getStatesMetaItems(): Observable<(IState & IMetaItem)[]> {
        return this.getStates().pipe(map((x) => x.map((x, Id) => ({ Id, ...x }))));
    }

    getCountriesMetaItems(): Observable<(ICountry & IMetaItem)[]> {
        return this.getCountries().pipe(map((x) => x.map((x, Id) => ({ Id, ...x }))));
    }
}
